import { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import CardBlock from './card-block';

const ellipsisStyle = css`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

interface CardBodyTextProps {
	ellipsis?: boolean;
}

const CardBodyText = styled.div<CardBodyTextProps>`
	font: var(--caption);
	color: var(rgba(var(--card-body-text-font-color), 1), rgb(var(--base-06)));
	${({ ellipsis }) => ellipsis && ellipsisStyle}
	display: flex;
	flex-direction: column;
	width: 100%;
`;

const CardBodyWrapper = styled(CardBlock)`
	flex: 3;
`;

interface CardBodyType {
	children?: ReactNode | ReactNode[];
}
const CardBody: FC<CardBodyType> = ({ children }) => (
	<CardBodyWrapper padding="0">
		<CardBodyText className="u-pr1 u-pl1 u-pb1">{children}</CardBodyText>
	</CardBodyWrapper>
);

export default CardBody;
